import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
  import CookieHelper from '@/helpers/CookieHelper'
  import eventBus from '@/main'
  import { UserModule } from '@/store/modules/user'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageTranslateToggle',
  setup(__props) {

  const { currentCourseId, moduleId, currentLesson } = useCourse()
  const { lessonViewed, languageTranslationToggled } = useSegment()
  const { languageTranslations } = useCommonMixin()

  const selectedLanguageCode = ref('de')
  const reRenderKey = ref('')

  const setLanguage = (languageEvent: any) => {
    if (typeof languageEvent === 'undefined') return
    if (!languageEvent || !languageEvent.code || !languageEvent.name) return

    selectedLanguageCode.value = languageEvent.code
    trackLessonViewedLanguage(languageEvent.code)

    if (languageEvent.code === 'de') {
      eventBus.$i18n.locale = 'de'
    } else {
      // we only track if it's not de
      languageTranslationToggled(languageEvent.name, languageEvent.code)
    }
  }

  const trackLessonViewedLanguage = (translationCode: string) => {
    if (
      eventBus.$route.name === 'Lesson' &&
      UserModule.currentCompany &&
      currentLesson.value &&
      moduleId &&
      currentCourseId.value
    ) {
      lessonViewed(
        UserModule.currentCompany.id,
        currentLesson.value.id,
        currentLesson.value.title,
        moduleId.value,
        currentCourseId.value,
        translationCode || 'de',
      )
    }
  }

  watch(selectedLanguageCode, (value) => {
    if (value) {
      CookieHelper.setCrossDomainCookie('language-code', value)
    }
  })

  onMounted(() => {
    reRenderKey.value = Math.random().toString(36).substring(2)
    const languageCode = CookieHelper.getCookieValue('language-code')
    if (languageCode) {
      selectedLanguageCode.value = languageCode
    }
  })

return { __sfc: true,currentCourseId, moduleId, currentLesson, lessonViewed, languageTranslationToggled, languageTranslations, selectedLanguageCode, reRenderKey, setLanguage, trackLessonViewedLanguage, onMounted, ref, watch, CookieHelper, eventBus, UserModule, useCourse, useSegment, useCommonMixin }
}

})